import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { BulletPoints } from '@/common/components/BulletPoints/BulletPoints';
import { Button } from '@/common/components/Button/Button';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { Stack } from '@/common/components/Stack/Stack';
import { Translate } from '@/common/components/Translate/Translate';
import { PLAN } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useMarket } from '@/common/hooks/useMarket';
import { tArray } from '@/common/utils/i18n';

export type TFringeLearningCenterProps = {
  onClose: () => void;
};

export function FringeLearningCenter({ onClose }: TFringeLearningCenterProps) {
  const { t } = useTranslation();
  const { plan } = useMarket();

  const isSucFringe = plan === PLAN.ITALY_FRINGE;

  const examplePoints = tArray<string>(
    isSucFringe
      ? 'learning_centre.italy-fringe.fringe.example.points'
      : 'learning_centre.fringe.example.points'
  );

  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[60rem]">
      <ModalLearning.Step
        title={t('learning_centre.fringe.title')}
        description={
          isSucFringe
            ? t('learning_centre.italy-fringe.fringe.subtitle')
            : t('learning_centre.fringe.subtitle')
        }
      />
      <ModalLearning.Step
        title={t('learning_centre.fringe.example.title')}
        description={
          <Stack gap="md">
            <Translate
              i18nKey={
                isSucFringe
                  ? 'learning_centre.italy-fringe.fringe.example.description'
                  : 'learning_centre.fringe.example.description'
              }
              parent={BodyText}
            />
            <BulletPoints points={examplePoints} />
            <Translate
              i18nKey={
                isSucFringe
                  ? 'learning_centre.italy-fringe.fringe.example.explanation'
                  : 'learning_centre.fringe.example.explanation'
              }
              parent={BodyText}
            />
          </Stack>
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-how-it-works.png')}
            transition={250}
          />
        }
      />
      <ModalLearning.Step
        title={t('learning_centre.fringe.card.coverflex_card')}
        description={
          <Stack gap="md">
            <Translate
              i18nKey={
                isSucFringe
                  ? 'learning_centre.italy-fringe.fringe.card.description'
                  : 'learning_centre.fringe.card.description'
              }
            />
            <RouterLink
              href={{
                pathname: ROUTES.WELFARE_CATEGORIES,
                params: { slug: 'fringe' },
              }}
            >
              <Button variant="tertiary" presentational size="sm">
                {t('learning_centre.fringe.example.link')}
              </Button>
            </RouterLink>
          </Stack>
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-coverflex-card.png')}
            transition={250}
          />
        }
      />
    </ModalLearning.Root>
  );
}
